exports = module.exports = require("../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3Za2g74GvBDb2xLKNo4ir5 .header-icon{padding:1.5rem;z-index:1;font-size:2rem;background:-webkit-gradient(linear, left top, left bottom, from(#eff5f7), color-stop(47.53%, #eff5f7), to(rgba(239,245,247,0)));background:linear-gradient(180deg, #eff5f7 0%, #eff5f7 47.53%, rgba(239,245,247,0) 100%);width:100%;position:fixed;top:0;left:0}@media (max-width: 767px){._3Za2g74GvBDb2xLKNo4ir5 .menu-view-beyond{margin-top:-200px}}._3Za2g74GvBDb2xLKNo4ir5 .menu-view{position:absolute;z-index:2;overflow:auto;width:100%;max-width:100%}._3Za2g74GvBDb2xLKNo4ir5 .menu-view>div{border-radius:0}._3Za2g74GvBDb2xLKNo4ir5 .menu-view>div ~ div{margin-top:1rem}\n", ""]);

// exports
exports.locals = {
	"packageContainer": "_3Za2g74GvBDb2xLKNo4ir5"
};